import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=0323074f&scoped=true&"
import script from "./DefaultButton.vue?vue&type=script&lang=js&"
export * from "./DefaultButton.vue?vue&type=script&lang=js&"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=0323074f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0323074f",
  null
  
)

export default component.exports